import LoginComponent from '@/components/login-component';
import { useTranslations } from 'next-intl';

const Magic = () => {
  const t = useTranslations('Pages.Magic');
  return <LoginComponent title={t('sign_in_via_magic')} view="magic_link"></LoginComponent>;
};

export default Magic;
